/**
 * @generated SignedSource<<0d76fa2d0050b491870f80282438e34d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueRow_nativeIssueTable_IssueRowWithFragments_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCellsConditionalFormatting_project">;
  readonly " $fragmentType": "issueRow_nativeIssueTable_IssueRowWithFragments_project";
};
export type issueRow_nativeIssueTable_IssueRowWithFragments_project$key = {
  readonly " $data"?: issueRow_nativeIssueTable_IssueRowWithFragments_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueRow_nativeIssueTable_IssueRowWithFragments_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "issueRow_nativeIssueTable_IssueRowWithFragments_project",
  "selections": [
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useCellsConditionalFormatting_project"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "128aeca0e604cff4b96616344f2fb333";

export default node;
